import { typeAccountPermit } from "../api/typeAccountPermit";

const actionTypeAccountPermit = {
  get: () => typeAccountPermit.get().then((response) => response),
};

export default actionTypeAccountPermit;
